import { FormRules } from "element-plus";

export const getRegisterRules = (
  form: any,
  options: { isOauthFlow?: boolean; isGoogleFlow?: boolean } = {},
): FormRules => {
  // `isGoogleFlow` se mantiene como alias retrocompatible; cualquier flujo OAuth
  // (Google o futuros proveedores) omite contraseña/confirmación de correo.
  const isOauthFlow = options.isOauthFlow ?? options.isGoogleFlow ?? false;

  // En el flujo OAuth no hay captura de contraseña ni confirmación de correo:
  // esos campos se omiten de la validación del formulario.
  const passwordRules: FormRules = isOauthFlow
    ? {}
    : {
        email_confirmation: [
          { required: true, message: "Campo requerido", trigger: "blur" },
          {
            validator: (_rule: any, value: string, callback: Function) => {
              if (value !== form.email) {
                callback(new Error("El correo no coincide"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "Campo requerido", trigger: ["blur"] },
          {
            min: 6,
            message: "Debe tener al menos 6 caracteres",
            trigger: ["blur"],
          },
          { max: 50, message: "Máximo 50 caracteres", trigger: "blur" },
        ],
        password_confirmation: [
          { required: true, message: "Campo requerido", trigger: "blur" },
          {
            validator: (_rule: any, value: string, callback: Function) => {
              if (value !== form.password) {
                callback(new Error("Las contraseñas no coinciden"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      };

  return {
  firstname: [
    {
      required: true,
      message: "Campo requerido",
      trigger: "blur",
    },
    { min: 3, message: "Mínimo 3 caracteres", trigger: "blur" },
    { max: 28, message: "Máximo 28 caracteres", trigger: "blur" },
  ],
  lastname: [
    {
      required: true,
      message: "Campo requerido",
      trigger: "blur",
    },
    { min: 3, message: "Mínimo 3 caracteres", trigger: "blur" },
    { max: 28, message: "Máximo 28 caracteres", trigger: "blur" },
  ],
  email: [
    { required: true, message: "Campo requerido", trigger: "blur" },
    {
      type: "email",
      message: "Formato de correo inválido",
      trigger: "blur",
    },
  ],
  ...passwordRules,
  phone: [
    {
      required: true,
      message: "Verifica que sea correcto, es necesario para validar la cuenta",
      trigger: "blur",
    },
    {
      min: 10,
      trigger: "blur",
      message: "Mínimo 10 caracteres",
    },
    {
      max: 10,
      trigger: "blur",
      message: "Máximo 10 caracteres",
    },
  ],
  idDiscount: [
    { required: true, message: "Campo requerido", trigger: "change" },
  ],
  company: [
    { required: true, message: "Campo requerido", trigger: "blur" },
    { min: 3, message: "Mínimo 3 caracteres", trigger: "blur" },
    { max: 120, message: "Máximo 120 caracteres", trigger: "blur" },
  ],
  productType1: [
    {
      required: true,
      message: "Selecciona un tipo de producto",
      trigger: "change",
    },
  ],
  nit: [
    { required: true, message: "Campo requerido", trigger: "blur" },
    { min: 6, message: "Mínimo 6 caracteres", trigger: "blur" },
    { max: 10, message: "Máximo 10 caracteres", trigger: "blur" },
  ],
  nit_val_number: [
    {
      pattern: /^[A-Za-z0-9]+$/,
      message: "Solo se permiten caracteres alfanuméricos",
      trigger: "blur",
    },
  ],
  terms: [
    {
      validator: (_rule: any, value: boolean, callback: Function) => {
        if (!value) {
          callback(new Error("Debes aceptar los términos y condiciones"));
        } else {
          callback();
        }
      },
      trigger: "change",
    },
  ],
  };
};
